
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexKuDNMbH2_I_ftfDD4eyyLUCpfcWHT98zuVTvNNdndjAMeta } from "/var/www/html/integrado/pages/accesorios/index.vue?macro=true";
import { default as index8vKmdImc5oSsWfoWaxGUZHwR3MRbfjysWr7TFB9h9ewMeta } from "/var/www/html/integrado/pages/afinamiento-motor/calendario/index.vue?macro=true";
import { default as indexIQkORhIBqSpvuuFuBe3FHhQ3QoBxBo9KGx8Nmk4L1J0Meta } from "/var/www/html/integrado/pages/afinamiento-motor/cliente/index.vue?macro=true";
import { default as indexAdTjzicYIieyrck7BYgfoiiuETsnfLJCQRpmOSc0UQYMeta } from "/var/www/html/integrado/pages/afinamiento-motor/failed/index.vue?macro=true";
import { default as index_vRiW33bbZmwad_U_fbBwPtGYebH1xv1CM_Me8Pi2GUMeta } from "/var/www/html/integrado/pages/afinamiento-motor/finish/index.vue?macro=true";
import { default as indexR_4502VAzcfSqPNpW2Zkk6xQcVN7qk8USvolno7stFyK0Meta } from "/var/www/html/integrado/pages/afinamiento-motor/index.vue?macro=true";
import { default as index1aUc10D632XktO6Pz46ichm1YYaqDqhV28SU6kxLNSUMeta } from "/var/www/html/integrado/pages/alineacion/calendario/index.vue?macro=true";
import { default as indexE_pLMbYXw0uMvUCkkzBsgj6kSqvOCmckQ9O_45QfPSv4AMeta } from "/var/www/html/integrado/pages/alineacion/cliente/index.vue?macro=true";
import { default as indexKe7dZOOiwLaQL9CiT_45eHgHrFhauyPYALxQwfVWXWWkQMeta } from "/var/www/html/integrado/pages/alineacion/failed/index.vue?macro=true";
import { default as indexH0GIYhzCZm5vERQJMDH3lpmkOR9HZPCFPvh9H6MJW8gMeta } from "/var/www/html/integrado/pages/alineacion/finish/index.vue?macro=true";
import { default as indexsaOlAHVgpqOoqI6y6cwRYAZSnv86QyfvgUyYN8CJE44Meta } from "/var/www/html/integrado/pages/alineacion/index.vue?macro=true";
import { default as indexKSNda69rgOk1HWe66A5Cwuf9Qko5LDmEMM3toUNCJzAMeta } from "/var/www/html/integrado/pages/amortiguadores/calendario/index.vue?macro=true";
import { default as indexHYZFfThhDC1Av61ktGo8jQjreqpe2ztLOZ2Qh1m4YzQMeta } from "/var/www/html/integrado/pages/amortiguadores/cliente/index.vue?macro=true";
import { default as indexPgVJ_eo8ixp0iluEN_45VrvmyNijrYZi6YJirNQ6GspOEMeta } from "/var/www/html/integrado/pages/amortiguadores/failed/index.vue?macro=true";
import { default as indexzTAAjwd5PJz1NT8hLiXjLRMh8qMWo1rLofd5Lsk8hIIMeta } from "/var/www/html/integrado/pages/amortiguadores/finish/index.vue?macro=true";
import { default as indexlCVmTdbDwuBoL2wnIe6XMc7yVQKkPQIzN81vj868ansMeta } from "/var/www/html/integrado/pages/amortiguadores/index.vue?macro=true";
import { default as index2a_leevS_L5hUNx0iCbu5X9iXXn9Uspra7iV_kZUBNkMeta } from "/var/www/html/integrado/pages/asociados/index.vue?macro=true";
import { default as index7mZR83RuzZcFOz97dB8_45T1K7rSrkK8hhaR_RMX_bVKAMeta } from "/var/www/html/integrado/pages/asociados/sumate/index.vue?macro=true";
import { default as index2WHDYZAvs6SXd4OE6_45pf2qBUwsn6z_45yHzGC1pVcER38Meta } from "/var/www/html/integrado/pages/balanceo/calendario/index.vue?macro=true";
import { default as indexFm2KdeGs_452Z_45aKiT7gBOP0_45v5EHrMMUs8viNxkLkeQ0Meta } from "/var/www/html/integrado/pages/balanceo/cliente/index.vue?macro=true";
import { default as indexu8UURIs_457GbhubSixpbNfBVxiZ_7dqom4htei3SbTfoMeta } from "/var/www/html/integrado/pages/balanceo/failed/index.vue?macro=true";
import { default as indexZ2DI1AxP0Pf0faeMktrqk89y_GsOC_8VoaD5j7Ny4kYMeta } from "/var/www/html/integrado/pages/balanceo/finish/index.vue?macro=true";
import { default as index7DZMpJaC2igQo8szMJc_45raXQKGm_45kOgBLPERI9EpK88Meta } from "/var/www/html/integrado/pages/balanceo/index.vue?macro=true";
import { default as _91url_amigable_938GPviLaA4shnMobAuU6AKwzgn5ePGxDuIhGULanBSwkMeta } from "/var/www/html/integrado/pages/bases-concurso/[url_amigable].vue?macro=true";
import { default as indexbLZu09MauPgm2RwykrdfdaXV__45fRvNID9qMfACPdJa8Meta } from "/var/www/html/integrado/pages/baterias/agendamiento/index.vue?macro=true";
import { default as indexnBUdsdI_Fpf_45vNNK3Yh1bJ_EgoTbSAfohJyJqy4tWdwMeta } from "/var/www/html/integrado/pages/baterias/calendario/index.vue?macro=true";
import { default as indexxAW5u3JVWNwJhURNuBou40bft9nClIRPzUqH6pEWvi4Meta } from "/var/www/html/integrado/pages/baterias/carro/index.vue?macro=true";
import { default as indexny_45tT_cFW3g2yogMPfv88ZbTiOoqyzDjExt_45gQsaPr0Meta } from "/var/www/html/integrado/pages/baterias/change/index.vue?macro=true";
import { default as indexVKeJHp9nVbrDdW6ijlQAAiVzcy9sKE9L4PRJXk_hoVQMeta } from "/var/www/html/integrado/pages/baterias/checkout/index.vue?macro=true";
import { default as index1rcYhOyLIXOvWXDjunsd0bdkra67SBPJPNso6IbXlnIMeta } from "/var/www/html/integrado/pages/baterias/cliente/index.vue?macro=true";
import { default as indexc8307YJUAdnrmnwpZVMIwbrbbkyYCLTt3UohjnpWTcYMeta } from "/var/www/html/integrado/pages/baterias/concepts/index.vue?macro=true";
import { default as indexaIDY8csIISrknpHibNJPTP6Q2VVP97Ngs1WIKVRBWRsMeta } from "/var/www/html/integrado/pages/baterias/failed/index.vue?macro=true";
import { default as indexR8CviG2q79B6z3rxey6Z81YgQQIrD3XwyNGvJ_45zc8PwMeta } from "/var/www/html/integrado/pages/baterias/finish/index.vue?macro=true";
import { default as indexBC1vYa_45DIHBnLR3mjmWlBtheQJDvaujf4ostRHfgBlYMeta } from "/var/www/html/integrado/pages/baterias/index.vue?macro=true";
import { default as indexUHb1ZJ4LAOGqjCxoV_tVwShBTdGnhvKtVzRm2oXus_45MMeta } from "/var/www/html/integrado/pages/baterias/instalacion/index.vue?macro=true";
import { default as indexnCs_0_44pS42Hc78d1oOX8E_45YtKMf_8pD_45O64BSRsRgMeta } from "/var/www/html/integrado/pages/baterias/mantenimiento/index.vue?macro=true";
import { default as indexBT_2yLMFobq9Y_w0l4B_1n3KDOVRpwFWnau33R_45ONUMMeta } from "/var/www/html/integrado/pages/baterias/parts/index.vue?macro=true";
import { default as _91local_id_93sbiLCAKqE39GzDu_45fddgS55sUrtHfXMkMIBRD5BmxkcMeta } from "/var/www/html/integrado/pages/baterias/pdp/[id]/[local_id].vue?macro=true";
import { default as _91measurePath_93sxrnMPNmrhxT_jDVxZ0ime3r7pBiJkK3_ZnCrxWU0R0Meta } from "/var/www/html/integrado/pages/baterias/plp/[measurePath].vue?macro=true";
import { default as indexXRf1r9wzs1_45nTysMzSzffq5nFAsy7kdTo5717iJqAPcMeta } from "/var/www/html/integrado/pages/baterias/plp/index.vue?macro=true";
import { default as indexCcwQMi8_yDkhsp6mC72uaNyU3dySryLKstULdOfg2SUMeta } from "/var/www/html/integrado/pages/baterias/type/index.vue?macro=true";
import { default as indexdLK4FjzFCfjPfsq8FGiIMJBf8aYhjAB5Q1rGKAwkAxQMeta } from "/var/www/html/integrado/pages/beneficios/index.vue?macro=true";
import { default as _91slug_93j9MCvHw6h1V1KJxLmjQDz8pzgr6rkYwdO95LMEq7ja8Meta } from "/var/www/html/integrado/pages/blog/[slug].vue?macro=true";
import { default as indexgCa7ni8Wb5BgwxrqnFCwhxFV5wl1o8XJvv0DrDkdIOsMeta } from "/var/www/html/integrado/pages/blog/index.vue?macro=true";
import { default as indexVfllXG9IIUz1rk3NC1SCIjVkdsUv9t3u75wOL7rALssMeta } from "/var/www/html/integrado/pages/boletas/index.vue?macro=true";
import { default as indexrRLmwKeAeDeUZGgrFtIJgtTHZbWB7S3pbJM2a9WO0BAMeta } from "/var/www/html/integrado/pages/cambio-de-aceite/calendario/index.vue?macro=true";
import { default as index7fr0SCxovOV_45JT5aW9gejwuAfZBPj6R6oci4Iu7iSEUMeta } from "/var/www/html/integrado/pages/cambio-de-aceite/cliente/index.vue?macro=true";
import { default as indexH29meRGY1zl94qcKwprBGltsMjrtLIMSG9Fp8jGjdPkMeta } from "/var/www/html/integrado/pages/cambio-de-aceite/failed/index.vue?macro=true";
import { default as index0PGLKASJjIk86Wlf9ujMydmh9_2aXakUvc7NizBhUJ0Meta } from "/var/www/html/integrado/pages/cambio-de-aceite/finish/index.vue?macro=true";
import { default as indexWs0RVpksNLskiTe3LLM0a2RqJ1NlLqg2fERXpSSBQEYMeta } from "/var/www/html/integrado/pages/cambio-de-aceite/index.vue?macro=true";
import { default as indexYmh705Bj6skQR7gi7Gs2BLfFMwF26OvdbAHdTSMZMcgMeta } from "/var/www/html/integrado/pages/cambio-de-aceite/local/index.vue?macro=true";
import { default as indexCTqa8RuejtWWRH5ACrgpUlV4JdSMyiQwzkTxcvpVDFsMeta } from "/var/www/html/integrado/pages/cambio-de-aceite/plp/index.vue?macro=true";
import { default as desuscribirPTDLtwTVqfIfHHoy_45yZPBW6zg41G_CK0hQRvycIePtQMeta } from "/var/www/html/integrado/pages/carrito/desuscribir.vue?macro=true";
import { default as indexmCPZkLZeJ7AYCrBXT3RoOonFUQEOR3h80Z16OjKp8koMeta } from "/var/www/html/integrado/pages/concursos-promociones/index.vue?macro=true";
import { default as indexo9MokOPzWzeasNe69D1gWUb_45kmp0stKzpy_T1tk_45fvEMeta } from "/var/www/html/integrado/pages/electrico-automotriz/calendario/index.vue?macro=true";
import { default as indexD9CfC4uvrDVKcLa1yNYtxsCUymNYd7mcehB85U7NAPAMeta } from "/var/www/html/integrado/pages/electrico-automotriz/cliente/index.vue?macro=true";
import { default as indexcIx7T1PAKKmln4K6IzGT99dDzBL_45NFkmuTFc8_J71e0Meta } from "/var/www/html/integrado/pages/electrico-automotriz/failed/index.vue?macro=true";
import { default as indexI3v_45PHaDh3uVN5kwka49oSzDIDKWzqmicJEyk6CIKJkMeta } from "/var/www/html/integrado/pages/electrico-automotriz/finish/index.vue?macro=true";
import { default as indexCdPrve9zISIJbar3n6dzUEDEYnUkN8FSVTgDflzkNeoMeta } from "/var/www/html/integrado/pages/electrico-automotriz/index.vue?macro=true";
import { default as indexitefTLWxVOSbxz1lumHEkSw53BJ5TvcdyQjFnTyQ79EMeta } from "/var/www/html/integrado/pages/fluidos/calendario/index.vue?macro=true";
import { default as indexAcCf_45XjidRb8BBCTcTZlAZPaEeaNRVCjjactqDGit4UMeta } from "/var/www/html/integrado/pages/fluidos/cliente/index.vue?macro=true";
import { default as indexZpu20jPMUB79OiGmkTpL5kvV5XawGisDgVIgaFf0_45H8Meta } from "/var/www/html/integrado/pages/fluidos/failed/index.vue?macro=true";
import { default as indexk_F5808hBfwSJhPC2ytHfTT7wN29zfbum8qtU0_45Qx8gMeta } from "/var/www/html/integrado/pages/fluidos/finish/index.vue?macro=true";
import { default as indexIQkEWh0ogi8tc_kVQ8wqTvvsUgl79uaHGAewIdMcDbwMeta } from "/var/www/html/integrado/pages/fluidos/index.vue?macro=true";
import { default as _91id_93XFbOWgjGqUKWAnAfdo4mSAZY2QBJ0Zal27b1cApvvKAMeta } from "/var/www/html/integrado/pages/formulario-campania/[id].vue?macro=true";
import { default as index2KAtzf7mG1IrHhzFmpQeUgryML03AXnWUsakVLaRq8sMeta } from "/var/www/html/integrado/pages/frenos/calendario/index.vue?macro=true";
import { default as indexY5Lv_45pH0UlRFO6f8bvOxoaK_PV4HJiIA0GP93Np4t2IMeta } from "/var/www/html/integrado/pages/frenos/cliente/index.vue?macro=true";
import { default as indexg8WuMazAJvrS_45X63QOc8BTFLKk0rspgI6_801_45tBulEMeta } from "/var/www/html/integrado/pages/frenos/failed/index.vue?macro=true";
import { default as indexOe0kdrQYwF93ju8TWqesXUCPwI6Cs_ST9_45s3Li6LHfsMeta } from "/var/www/html/integrado/pages/frenos/finish/index.vue?macro=true";
import { default as index0lU_45O8w5_2IYRSb9vS9i28qsaeRlyQtaoJs_2ay56RAMeta } from "/var/www/html/integrado/pages/frenos/index.vue?macro=true";
import { default as _91url_amigable_93YhWSzodIbw5D5Qx5qEhl9OE8PZ1sU9CTokMNbQ3hJ8QMeta } from "/var/www/html/integrado/pages/ganadores-concurso/[url_amigable].vue?macro=true";
import { default as index1d7M7XLBqwyxrk4PL67_o2vHOxNdg893UcKZmizw62IMeta } from "/var/www/html/integrado/pages/geometria-automotriz/calendario/index.vue?macro=true";
import { default as indexhPuJlRl61CH34zk2yFZ28CNsC_NjovzUWIFBNNDPy7MMeta } from "/var/www/html/integrado/pages/geometria-automotriz/cliente/index.vue?macro=true";
import { default as indexzjqGIAVUyPGW_45bXDFfIq3Tyft0DGoNyo8P4EpYNz_kUMeta } from "/var/www/html/integrado/pages/geometria-automotriz/failed/index.vue?macro=true";
import { default as indexaifyI644UmxK8wPl2bqwFxhCibEfvTsYUqoqof_xnQkMeta } from "/var/www/html/integrado/pages/geometria-automotriz/finish/index.vue?macro=true";
import { default as indexToG0QrrsgAYGdZKrnhbSrJ0y7J5_451O7sPIvJJ0d5obwMeta } from "/var/www/html/integrado/pages/geometria-automotriz/index.vue?macro=true";
import { default as index1feTQhcVHcn4ZPg9cB9CjuqWhB1gx7vHvzfmGUVZmG8Meta } from "/var/www/html/integrado/pages/higienizacion/calendario/index.vue?macro=true";
import { default as indexhA0k9INsBTQVxvt4XY_45U_ihLCJKfNUEXicAlunSIqi4Meta } from "/var/www/html/integrado/pages/higienizacion/cliente/index.vue?macro=true";
import { default as indexJrFasr6HB69o2ZaxUsDop1BhKVNaOb19R4ufgGIsKcwMeta } from "/var/www/html/integrado/pages/higienizacion/failed/index.vue?macro=true";
import { default as index38gGH28Sqk76N1KhTtUKSBqAmgRSia1OaXkzB1aD48cMeta } from "/var/www/html/integrado/pages/higienizacion/finish/index.vue?macro=true";
import { default as indexjnkyZO1ZzSSqC4zYfYOKnuNqDVVli4wo_45VavbMUd4OsMeta } from "/var/www/html/integrado/pages/higienizacion/index.vue?macro=true";
import { default as indexvRqp4FoTtmNsk1O3J_45U3YpZTmvkbJhareAeeQHRS3XgMeta } from "/var/www/html/integrado/pages/index.vue?macro=true";
import { default as indexb9I_9v8aFNPZ57GnT1Gq08YZkf6Xpauq2iSYjfE5CXsMeta } from "/var/www/html/integrado/pages/mantencion-kilometraje/calendario/index.vue?macro=true";
import { default as indexuaubN5oe0_45CqDUTwdGRLVSVuJgmpY1M1txRa6v7fmv4Meta } from "/var/www/html/integrado/pages/mantencion-kilometraje/cliente/index.vue?macro=true";
import { default as indexuWczbCJ_6f8XaEVwYWrl5r6LkkXD_45rAlTndsx_45gQD2MMeta } from "/var/www/html/integrado/pages/mantencion-kilometraje/failed/index.vue?macro=true";
import { default as indexdot0LMS_45HjJ6fQKroYqIqm1bLdm6TrtFuCK9lNZEyUQMeta } from "/var/www/html/integrado/pages/mantencion-kilometraje/finish/index.vue?macro=true";
import { default as indexPp8yx7OS8gc9Dh9SKBAWFxmizYn4N_HpcheVx7nSxc4Meta } from "/var/www/html/integrado/pages/mantencion-kilometraje/index.vue?macro=true";
import { default as indexorETq06CORHDbhW8DpJcfEtjsDwJiDmDiwesNQftwk8Meta } from "/var/www/html/integrado/pages/medios-de-pago/index.vue?macro=true";
import { default as indexDYKMMo_45ApJTlYsNS8x8jHZ3XiePqUnQ7UfYKiYhT7UEMeta } from "/var/www/html/integrado/pages/neumaticos/agendamiento/index.vue?macro=true";
import { default as indexUBkE4Pe8GcUl80n7NzWJjMSnve1V1K9xMLHDRXmXl9gMeta } from "/var/www/html/integrado/pages/neumaticos/carro/index.vue?macro=true";
import { default as indexwaL_2IGT7jLfsVz1AiWKWuSkI048mB3xjrJtlTniAB8Meta } from "/var/www/html/integrado/pages/neumaticos/checkout/index.vue?macro=true";
import { default as indexiOyBLayuIWcFxALSsBTgv9KdmICJW_5RRTqMb_I1nmYMeta } from "/var/www/html/integrado/pages/neumaticos/detail/index.vue?macro=true";
import { default as indexuKTIaumnJt5xs0ThN4DwSNcoC6r4VokiNR0vgWr4QzwMeta } from "/var/www/html/integrado/pages/neumaticos/failed/index.vue?macro=true";
import { default as indexM9J61cySimjygX9UiucZ8gqGaoDCt0RHb7LwnlmhdTQMeta } from "/var/www/html/integrado/pages/neumaticos/finish/index.vue?macro=true";
import { default as indexpgJOBnEUSI_45di1dTW5c_45RS85dE2WbwLeLMEeewjKkVEMeta } from "/var/www/html/integrado/pages/neumaticos/guide/index.vue?macro=true";
import { default as indexKR_45pDOhXe_45qas_45kPjIrdd5SiGEJ_45Q3ECaDQ51SoeRtoMeta } from "/var/www/html/integrado/pages/neumaticos/index.vue?macro=true";
import { default as indexb1VFMyLgdSseowLwXMQTE3AVVEZpm84_45dVVMA_45EFMz4Meta } from "/var/www/html/integrado/pages/neumaticos/instalacion/index.vue?macro=true";
import { default as indexqJZsRfEKFMwcreWrO41iJQ6DRlYhxDh3VHFZ486BJ7wMeta } from "/var/www/html/integrado/pages/neumaticos/more/index.vue?macro=true";
import { default as _91local_id_93UV3anGD0JWZqIcGz_ltCuJBKxTGS1TDfgwr_y0qDCQIMeta } from "/var/www/html/integrado/pages/neumaticos/pdp/[id]/[local_id].vue?macro=true";
import { default as indexBkrX4OhS_mK_tpd2KYPuMVnySuKnj8upYV8a_SGpQdQMeta } from "/var/www/html/integrado/pages/neumaticos/plp-doble/index.vue?macro=true";
import { default as _91measurePath_935QX_45LdmP8e6M7VY2ACzoEniEaFXRHOVTtQXH5CO8fUEMeta } from "/var/www/html/integrado/pages/neumaticos/plp/[measurePath].vue?macro=true";
import { default as indextIyMMdbpFlGs1dzyRle9rY7XJnUD9POtzj9gKBfxYBoMeta } from "/var/www/html/integrado/pages/neumaticos/plp/index.vue?macro=true";
import { default as index6AkwobYp9x8YN9b1T0m5qrf9nXzvGM6tWHEJWKZnm_kMeta } from "/var/www/html/integrado/pages/neumaticos/signal/index.vue?macro=true";
import { default as indexTeY_45BCn6biDP3jHzjWWRs_45o7MHVRPlWu2WZV6EDuPJIMeta } from "/var/www/html/integrado/pages/neumaticos/tips/index.vue?macro=true";
import { default as indexgdL4F73H76sSRx_vjXc21bhd4igpkfivcfMuGYIWrAgMeta } from "/var/www/html/integrado/pages/neumaticos/vehicle/index.vue?macro=true";
import { default as index_45hZngx88ndemRe7bss66fUn7AAWyay_FyS0rtVL51o8Meta } from "/var/www/html/integrado/pages/nuestros-locales/index.vue?macro=true";
import { default as index8rzZK5y9ZTRUSGa9I_45AXxQIpb4_45tYjyO4d7LLXfyplMMeta } from "/var/www/html/integrado/pages/nuestros-locales/local-antofagasta/index.vue?macro=true";
import { default as indexb2XOtvsP7X1ZHS5bAqKcquQbXVI9BHl_LTiBEEMpmSsMeta } from "/var/www/html/integrado/pages/nuestros-locales/local-chicureo/index.vue?macro=true";
import { default as indexap3HOXk_450o7poucuS6jczmYfCdJ8IR7LCWaGBA_2wpQMeta } from "/var/www/html/integrado/pages/nuestros-locales/local-colon/index.vue?macro=true";
import { default as indexXwUVxop9GQYk0AnbZ6ZwSzkZPoyoVdCOyNHmgC4HbVQMeta } from "/var/www/html/integrado/pages/nuestros-locales/local-concepcion/index.vue?macro=true";
import { default as indexhF_o4LaKH8T7nlU6jG6gS_9oRwoHepC6WumaK4kOMy8Meta } from "/var/www/html/integrado/pages/nuestros-locales/local-diagonal/index.vue?macro=true";
import { default as indexqTgZli_45LgqavcPhXIaN5Jya6k5c6WsS5UwSFrvxUV_wMeta } from "/var/www/html/integrado/pages/nuestros-locales/local-estoril/index.vue?macro=true";
import { default as indexsZFid8YyXpW2YXCleo_45sLhx6j0TZiIzNfV8kOqgVEz4Meta } from "/var/www/html/integrado/pages/nuestros-locales/local-irarrazaval/index.vue?macro=true";
import { default as index6Z6BpApZOVXlw6Dgulu54G9mT8ygzR7ejsqgpsnjnTYMeta } from "/var/www/html/integrado/pages/nuestros-locales/local-laflorida/index.vue?macro=true";
import { default as index2Bkwj_jlx1loSZMB9yUcupaFqubvbYDLeRSNUyx5T20Meta } from "/var/www/html/integrado/pages/nuestros-locales/local-laserena/index.vue?macro=true";
import { default as indexjjYKcHhq2ngJCGu4dBbnUYsBT02wUtWPyBIo2FGQ1RkMeta } from "/var/www/html/integrado/pages/nuestros-locales/local-maipu/index.vue?macro=true";
import { default as index_45_1wYtVdP8k4zZ__45FUBtgx0FRi1_45mg2pkpddDD4GoGoMeta } from "/var/www/html/integrado/pages/nuestros-locales/local-penalolen/index.vue?macro=true";
import { default as index813FbTvdg8Ij9_456gfFHR49aVuushgD37Jax6G6LLSv4Meta } from "/var/www/html/integrado/pages/nuestros-locales/local-puertomontt/index.vue?macro=true";
import { default as index9zbB7gojaBB0aQI48MF1TCacYago3QheLR1u1bubCWUMeta } from "/var/www/html/integrado/pages/nuestros-locales/local-rancagua/index.vue?macro=true";
import { default as indexW33Qa8116ldXwU8lG8MHLUmgnbWXHmYl_45xr5bg5TaIIMeta } from "/var/www/html/integrado/pages/nuestros-locales/local-vicmack/index.vue?macro=true";
import { default as indexsDwNKOD3mhzBnQIGWGfSLcuQysm1ru1ZZ1TfyDImFpYMeta } from "/var/www/html/integrado/pages/nuestros-locales/local-vina/index.vue?macro=true";
import { default as indexKfk6Au3FVl_45ha2lZQd0wioYx9YPJjfIZXOvPaOdja0AMeta } from "/var/www/html/integrado/pages/nuestros-locales/local-vitacura/index.vue?macro=true";
import { default as index4g3Eh_wIvjPEZMWClERbo_RlVdeSS1S8ERxa4rzkpAIMeta } from "/var/www/html/integrado/pages/politica-datos-personales/index.vue?macro=true";
import { default as index1MVvFCDuZrKfRxXfanakOd4PVfzE3g8CrA_mcjEhhAQMeta } from "/var/www/html/integrado/pages/por-definir/index.vue?macro=true";
import { default as gracias5vHFRFwKxoHS8avoCfYJ78Fgp_6eK2EZl2fPAg2Ku38Meta } from "/var/www/html/integrado/pages/postulaciones/gracias.vue?macro=true";
import { default as indexsvytxfcfAY4ZfBpkxHAaZsCH9W1zuB1O0bZpvxRb2IwMeta } from "/var/www/html/integrado/pages/postulaciones/index.vue?macro=true";
import { default as indexBrPIcplJ8HkOskjA5KyEYKdSPoHRY84ogQ_45V3XjxmC0Meta } from "/var/www/html/integrado/pages/quienes-somos/index.vue?macro=true";
import { default as indexxq0YJB_4553gxC4h3DS5CzKHNiUN8EMQxgKJQqpwxlwdMMeta } from "/var/www/html/integrado/pages/retiro-y-entrega/index.vue?macro=true";
import { default as indexUoYkWYnGXNgTs7mwhV2S8DRV2LacTvfG_45JnCTauOsicMeta } from "/var/www/html/integrado/pages/revision-tecnica/calendario/index.vue?macro=true";
import { default as indexQH9T_nMe2wPY_WdlmkHrhM5QaqvJBm_45_45rBAKtsPTYh8Meta } from "/var/www/html/integrado/pages/revision-tecnica/cliente/index.vue?macro=true";
import { default as indexe3out4qwvsVli2VNy3mGoHZlus9v4jXJv0D601wLT_YMeta } from "/var/www/html/integrado/pages/revision-tecnica/failed/index.vue?macro=true";
import { default as indexmxzmRfdqdVhsxDco_8IACOkIIbsy6_45JrfMvk3OM1NvkMeta } from "/var/www/html/integrado/pages/revision-tecnica/finish/index.vue?macro=true";
import { default as index85re7tZENXoWzqyR9HAVm_N5uPeSUY3lfIheEnBhO58Meta } from "/var/www/html/integrado/pages/revision-tecnica/index.vue?macro=true";
import { default as indexbvAoTWKDzQfsew_gOb0IvXuTPSCeRrL36D1WHwbUcRQMeta } from "/var/www/html/integrado/pages/revision-tecnica/servicio/index.vue?macro=true";
import { default as indexWUoxJVjLUbMfIlsLyLOQesrs_45bYb3S6Kd4g3gTlWyJAMeta } from "/var/www/html/integrado/pages/seguridad-y-privacidad/index.vue?macro=true";
import { default as index3KExoOdx0FDPITj8GYnGi6VMOS7P6GqJim2po0J0xrEMeta } from "/var/www/html/integrado/pages/terminos-y-condiciones/index.vue?macro=true";
import { default as indexJNRbnTxjv2VGb29WVK_45e0tr_13Kox9bAtyyhA6Y3hX8Meta } from "/var/www/html/integrado/pages/tren-delantero/calendario/index.vue?macro=true";
import { default as indexvh3O7iu22MyO_45v_shzVoUgDGW850xOl_v5s2Sy2clYcMeta } from "/var/www/html/integrado/pages/tren-delantero/cliente/index.vue?macro=true";
import { default as indexkwI9G9kwHEzcRljJ5O9pOchTGlFQ0gus_Y66ayWzaHEMeta } from "/var/www/html/integrado/pages/tren-delantero/failed/index.vue?macro=true";
import { default as index83DZhzxRyqf_45IBiR5c9HDINOOUlkVv5zwVyzk9sDnDIMeta } from "/var/www/html/integrado/pages/tren-delantero/finish/index.vue?macro=true";
import { default as indexs365Vtyv8fq2ozofsaSwVo_Glk1xysdZt7lR1CEhhqoMeta } from "/var/www/html/integrado/pages/tren-delantero/index.vue?macro=true";
export default [
  {
    name: "accesorios",
    path: "/accesorios",
    component: () => import("/var/www/html/integrado/pages/accesorios/index.vue")
  },
  {
    name: "afinamiento-motor-calendario",
    path: "/afinamiento-motor/calendario",
    component: () => import("/var/www/html/integrado/pages/afinamiento-motor/calendario/index.vue")
  },
  {
    name: "afinamiento-motor-cliente",
    path: "/afinamiento-motor/cliente",
    component: () => import("/var/www/html/integrado/pages/afinamiento-motor/cliente/index.vue")
  },
  {
    name: "afinamiento-motor-failed",
    path: "/afinamiento-motor/failed",
    component: () => import("/var/www/html/integrado/pages/afinamiento-motor/failed/index.vue")
  },
  {
    name: "afinamiento-motor-finish",
    path: "/afinamiento-motor/finish",
    component: () => import("/var/www/html/integrado/pages/afinamiento-motor/finish/index.vue")
  },
  {
    name: "afinamiento-motor",
    path: "/afinamiento-motor",
    component: () => import("/var/www/html/integrado/pages/afinamiento-motor/index.vue")
  },
  {
    name: "alineacion-calendario",
    path: "/alineacion/calendario",
    component: () => import("/var/www/html/integrado/pages/alineacion/calendario/index.vue")
  },
  {
    name: "alineacion-cliente",
    path: "/alineacion/cliente",
    component: () => import("/var/www/html/integrado/pages/alineacion/cliente/index.vue")
  },
  {
    name: "alineacion-failed",
    path: "/alineacion/failed",
    component: () => import("/var/www/html/integrado/pages/alineacion/failed/index.vue")
  },
  {
    name: "alineacion-finish",
    path: "/alineacion/finish",
    component: () => import("/var/www/html/integrado/pages/alineacion/finish/index.vue")
  },
  {
    name: "alineacion",
    path: "/alineacion",
    component: () => import("/var/www/html/integrado/pages/alineacion/index.vue")
  },
  {
    name: "amortiguadores-calendario",
    path: "/amortiguadores/calendario",
    component: () => import("/var/www/html/integrado/pages/amortiguadores/calendario/index.vue")
  },
  {
    name: "amortiguadores-cliente",
    path: "/amortiguadores/cliente",
    component: () => import("/var/www/html/integrado/pages/amortiguadores/cliente/index.vue")
  },
  {
    name: "amortiguadores-failed",
    path: "/amortiguadores/failed",
    component: () => import("/var/www/html/integrado/pages/amortiguadores/failed/index.vue")
  },
  {
    name: "amortiguadores-finish",
    path: "/amortiguadores/finish",
    component: () => import("/var/www/html/integrado/pages/amortiguadores/finish/index.vue")
  },
  {
    name: "amortiguadores",
    path: "/amortiguadores",
    component: () => import("/var/www/html/integrado/pages/amortiguadores/index.vue")
  },
  {
    name: "asociados",
    path: "/asociados",
    component: () => import("/var/www/html/integrado/pages/asociados/index.vue")
  },
  {
    name: "asociados-sumate",
    path: "/asociados/sumate",
    component: () => import("/var/www/html/integrado/pages/asociados/sumate/index.vue")
  },
  {
    name: "balanceo-calendario",
    path: "/balanceo/calendario",
    component: () => import("/var/www/html/integrado/pages/balanceo/calendario/index.vue")
  },
  {
    name: "balanceo-cliente",
    path: "/balanceo/cliente",
    component: () => import("/var/www/html/integrado/pages/balanceo/cliente/index.vue")
  },
  {
    name: "balanceo-failed",
    path: "/balanceo/failed",
    component: () => import("/var/www/html/integrado/pages/balanceo/failed/index.vue")
  },
  {
    name: "balanceo-finish",
    path: "/balanceo/finish",
    component: () => import("/var/www/html/integrado/pages/balanceo/finish/index.vue")
  },
  {
    name: "balanceo",
    path: "/balanceo",
    component: () => import("/var/www/html/integrado/pages/balanceo/index.vue")
  },
  {
    name: "bases-concurso-url_amigable",
    path: "/bases-concurso/:url_amigable()",
    component: () => import("/var/www/html/integrado/pages/bases-concurso/[url_amigable].vue")
  },
  {
    name: "baterias-agendamiento",
    path: "/baterias/agendamiento",
    component: () => import("/var/www/html/integrado/pages/baterias/agendamiento/index.vue")
  },
  {
    name: "baterias-calendario",
    path: "/baterias/calendario",
    component: () => import("/var/www/html/integrado/pages/baterias/calendario/index.vue")
  },
  {
    name: "baterias-carro",
    path: "/baterias/carro",
    component: () => import("/var/www/html/integrado/pages/baterias/carro/index.vue")
  },
  {
    name: "baterias-change",
    path: "/baterias/change",
    meta: indexny_45tT_cFW3g2yogMPfv88ZbTiOoqyzDjExt_45gQsaPr0Meta || {},
    component: () => import("/var/www/html/integrado/pages/baterias/change/index.vue")
  },
  {
    name: "baterias-checkout",
    path: "/baterias/checkout",
    component: () => import("/var/www/html/integrado/pages/baterias/checkout/index.vue")
  },
  {
    name: "baterias-cliente",
    path: "/baterias/cliente",
    component: () => import("/var/www/html/integrado/pages/baterias/cliente/index.vue")
  },
  {
    name: "baterias-concepts",
    path: "/baterias/concepts",
    meta: indexc8307YJUAdnrmnwpZVMIwbrbbkyYCLTt3UohjnpWTcYMeta || {},
    component: () => import("/var/www/html/integrado/pages/baterias/concepts/index.vue")
  },
  {
    name: "baterias-failed",
    path: "/baterias/failed",
    component: () => import("/var/www/html/integrado/pages/baterias/failed/index.vue")
  },
  {
    name: "baterias-finish",
    path: "/baterias/finish",
    component: () => import("/var/www/html/integrado/pages/baterias/finish/index.vue")
  },
  {
    name: "baterias",
    path: "/baterias",
    component: () => import("/var/www/html/integrado/pages/baterias/index.vue")
  },
  {
    name: "baterias-instalacion",
    path: "/baterias/instalacion",
    component: () => import("/var/www/html/integrado/pages/baterias/instalacion/index.vue")
  },
  {
    name: "baterias-mantenimiento",
    path: "/baterias/mantenimiento",
    meta: indexnCs_0_44pS42Hc78d1oOX8E_45YtKMf_8pD_45O64BSRsRgMeta || {},
    component: () => import("/var/www/html/integrado/pages/baterias/mantenimiento/index.vue")
  },
  {
    name: "baterias-parts",
    path: "/baterias/parts",
    component: () => import("/var/www/html/integrado/pages/baterias/parts/index.vue")
  },
  {
    name: "baterias-pdp-id-local_id",
    path: "/baterias/pdp/:id()/:local_id()",
    component: () => import("/var/www/html/integrado/pages/baterias/pdp/[id]/[local_id].vue")
  },
  {
    name: "baterias-plp-measurePath",
    path: "/baterias/plp/:measurePath()",
    component: () => import("/var/www/html/integrado/pages/baterias/plp/[measurePath].vue")
  },
  {
    name: "baterias-plp",
    path: "/baterias/plp",
    component: () => import("/var/www/html/integrado/pages/baterias/plp/index.vue")
  },
  {
    name: "baterias-type",
    path: "/baterias/type",
    meta: indexCcwQMi8_yDkhsp6mC72uaNyU3dySryLKstULdOfg2SUMeta || {},
    component: () => import("/var/www/html/integrado/pages/baterias/type/index.vue")
  },
  {
    name: "beneficios",
    path: "/beneficios",
    component: () => import("/var/www/html/integrado/pages/beneficios/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/var/www/html/integrado/pages/blog/[slug].vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/var/www/html/integrado/pages/blog/index.vue")
  },
  {
    name: "boletas",
    path: "/boletas",
    component: () => import("/var/www/html/integrado/pages/boletas/index.vue")
  },
  {
    name: "cambio-de-aceite-calendario",
    path: "/cambio-de-aceite/calendario",
    component: () => import("/var/www/html/integrado/pages/cambio-de-aceite/calendario/index.vue")
  },
  {
    name: "cambio-de-aceite-cliente",
    path: "/cambio-de-aceite/cliente",
    component: () => import("/var/www/html/integrado/pages/cambio-de-aceite/cliente/index.vue")
  },
  {
    name: "cambio-de-aceite-failed",
    path: "/cambio-de-aceite/failed",
    component: () => import("/var/www/html/integrado/pages/cambio-de-aceite/failed/index.vue")
  },
  {
    name: "cambio-de-aceite-finish",
    path: "/cambio-de-aceite/finish",
    component: () => import("/var/www/html/integrado/pages/cambio-de-aceite/finish/index.vue")
  },
  {
    name: "cambio-de-aceite",
    path: "/cambio-de-aceite",
    component: () => import("/var/www/html/integrado/pages/cambio-de-aceite/index.vue")
  },
  {
    name: "cambio-de-aceite-local",
    path: "/cambio-de-aceite/local",
    component: () => import("/var/www/html/integrado/pages/cambio-de-aceite/local/index.vue")
  },
  {
    name: "cambio-de-aceite-plp",
    path: "/cambio-de-aceite/plp",
    component: () => import("/var/www/html/integrado/pages/cambio-de-aceite/plp/index.vue")
  },
  {
    name: "carrito-desuscribir",
    path: "/carrito/desuscribir",
    component: () => import("/var/www/html/integrado/pages/carrito/desuscribir.vue")
  },
  {
    name: "concursos-promociones",
    path: "/concursos-promociones",
    component: () => import("/var/www/html/integrado/pages/concursos-promociones/index.vue")
  },
  {
    name: "electrico-automotriz-calendario",
    path: "/electrico-automotriz/calendario",
    component: () => import("/var/www/html/integrado/pages/electrico-automotriz/calendario/index.vue")
  },
  {
    name: "electrico-automotriz-cliente",
    path: "/electrico-automotriz/cliente",
    component: () => import("/var/www/html/integrado/pages/electrico-automotriz/cliente/index.vue")
  },
  {
    name: "electrico-automotriz-failed",
    path: "/electrico-automotriz/failed",
    component: () => import("/var/www/html/integrado/pages/electrico-automotriz/failed/index.vue")
  },
  {
    name: "electrico-automotriz-finish",
    path: "/electrico-automotriz/finish",
    component: () => import("/var/www/html/integrado/pages/electrico-automotriz/finish/index.vue")
  },
  {
    name: "electrico-automotriz",
    path: "/electrico-automotriz",
    component: () => import("/var/www/html/integrado/pages/electrico-automotriz/index.vue")
  },
  {
    name: "fluidos-calendario",
    path: "/fluidos/calendario",
    component: () => import("/var/www/html/integrado/pages/fluidos/calendario/index.vue")
  },
  {
    name: "fluidos-cliente",
    path: "/fluidos/cliente",
    component: () => import("/var/www/html/integrado/pages/fluidos/cliente/index.vue")
  },
  {
    name: "fluidos-failed",
    path: "/fluidos/failed",
    component: () => import("/var/www/html/integrado/pages/fluidos/failed/index.vue")
  },
  {
    name: "fluidos-finish",
    path: "/fluidos/finish",
    component: () => import("/var/www/html/integrado/pages/fluidos/finish/index.vue")
  },
  {
    name: "fluidos",
    path: "/fluidos",
    component: () => import("/var/www/html/integrado/pages/fluidos/index.vue")
  },
  {
    name: "formulario-campania-id",
    path: "/formulario-campania/:id()",
    component: () => import("/var/www/html/integrado/pages/formulario-campania/[id].vue")
  },
  {
    name: "frenos-calendario",
    path: "/frenos/calendario",
    component: () => import("/var/www/html/integrado/pages/frenos/calendario/index.vue")
  },
  {
    name: "frenos-cliente",
    path: "/frenos/cliente",
    component: () => import("/var/www/html/integrado/pages/frenos/cliente/index.vue")
  },
  {
    name: "frenos-failed",
    path: "/frenos/failed",
    component: () => import("/var/www/html/integrado/pages/frenos/failed/index.vue")
  },
  {
    name: "frenos-finish",
    path: "/frenos/finish",
    component: () => import("/var/www/html/integrado/pages/frenos/finish/index.vue")
  },
  {
    name: "frenos",
    path: "/frenos",
    component: () => import("/var/www/html/integrado/pages/frenos/index.vue")
  },
  {
    name: "ganadores-concurso-url_amigable",
    path: "/ganadores-concurso/:url_amigable()",
    component: () => import("/var/www/html/integrado/pages/ganadores-concurso/[url_amigable].vue")
  },
  {
    name: "geometria-automotriz-calendario",
    path: "/geometria-automotriz/calendario",
    component: () => import("/var/www/html/integrado/pages/geometria-automotriz/calendario/index.vue")
  },
  {
    name: "geometria-automotriz-cliente",
    path: "/geometria-automotriz/cliente",
    component: () => import("/var/www/html/integrado/pages/geometria-automotriz/cliente/index.vue")
  },
  {
    name: "geometria-automotriz-failed",
    path: "/geometria-automotriz/failed",
    component: () => import("/var/www/html/integrado/pages/geometria-automotriz/failed/index.vue")
  },
  {
    name: "geometria-automotriz-finish",
    path: "/geometria-automotriz/finish",
    component: () => import("/var/www/html/integrado/pages/geometria-automotriz/finish/index.vue")
  },
  {
    name: "geometria-automotriz",
    path: "/geometria-automotriz",
    component: () => import("/var/www/html/integrado/pages/geometria-automotriz/index.vue")
  },
  {
    name: "higienizacion-calendario",
    path: "/higienizacion/calendario",
    component: () => import("/var/www/html/integrado/pages/higienizacion/calendario/index.vue")
  },
  {
    name: "higienizacion-cliente",
    path: "/higienizacion/cliente",
    component: () => import("/var/www/html/integrado/pages/higienizacion/cliente/index.vue")
  },
  {
    name: "higienizacion-failed",
    path: "/higienizacion/failed",
    component: () => import("/var/www/html/integrado/pages/higienizacion/failed/index.vue")
  },
  {
    name: "higienizacion-finish",
    path: "/higienizacion/finish",
    component: () => import("/var/www/html/integrado/pages/higienizacion/finish/index.vue")
  },
  {
    name: "higienizacion",
    path: "/higienizacion",
    component: () => import("/var/www/html/integrado/pages/higienizacion/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/html/integrado/pages/index.vue")
  },
  {
    name: "mantencion-kilometraje-calendario",
    path: "/mantencion-kilometraje/calendario",
    component: () => import("/var/www/html/integrado/pages/mantencion-kilometraje/calendario/index.vue")
  },
  {
    name: "mantencion-kilometraje-cliente",
    path: "/mantencion-kilometraje/cliente",
    component: () => import("/var/www/html/integrado/pages/mantencion-kilometraje/cliente/index.vue")
  },
  {
    name: "mantencion-kilometraje-failed",
    path: "/mantencion-kilometraje/failed",
    component: () => import("/var/www/html/integrado/pages/mantencion-kilometraje/failed/index.vue")
  },
  {
    name: "mantencion-kilometraje-finish",
    path: "/mantencion-kilometraje/finish",
    component: () => import("/var/www/html/integrado/pages/mantencion-kilometraje/finish/index.vue")
  },
  {
    name: "mantencion-kilometraje",
    path: "/mantencion-kilometraje",
    component: () => import("/var/www/html/integrado/pages/mantencion-kilometraje/index.vue")
  },
  {
    name: "medios-de-pago",
    path: "/medios-de-pago",
    component: () => import("/var/www/html/integrado/pages/medios-de-pago/index.vue")
  },
  {
    name: "neumaticos-agendamiento",
    path: "/neumaticos/agendamiento",
    component: () => import("/var/www/html/integrado/pages/neumaticos/agendamiento/index.vue")
  },
  {
    name: "neumaticos-carro",
    path: "/neumaticos/carro",
    component: () => import("/var/www/html/integrado/pages/neumaticos/carro/index.vue")
  },
  {
    name: "neumaticos-checkout",
    path: "/neumaticos/checkout",
    component: () => import("/var/www/html/integrado/pages/neumaticos/checkout/index.vue")
  },
  {
    name: "neumaticos-detail",
    path: "/neumaticos/detail",
    meta: indexiOyBLayuIWcFxALSsBTgv9KdmICJW_5RRTqMb_I1nmYMeta || {},
    component: () => import("/var/www/html/integrado/pages/neumaticos/detail/index.vue")
  },
  {
    name: "neumaticos-failed",
    path: "/neumaticos/failed",
    component: () => import("/var/www/html/integrado/pages/neumaticos/failed/index.vue")
  },
  {
    name: "neumaticos-finish",
    path: "/neumaticos/finish",
    component: () => import("/var/www/html/integrado/pages/neumaticos/finish/index.vue")
  },
  {
    name: "neumaticos-guide",
    path: "/neumaticos/guide",
    meta: indexpgJOBnEUSI_45di1dTW5c_45RS85dE2WbwLeLMEeewjKkVEMeta || {},
    component: () => import("/var/www/html/integrado/pages/neumaticos/guide/index.vue")
  },
  {
    name: "neumaticos",
    path: "/neumaticos",
    component: () => import("/var/www/html/integrado/pages/neumaticos/index.vue")
  },
  {
    name: "neumaticos-instalacion",
    path: "/neumaticos/instalacion",
    component: () => import("/var/www/html/integrado/pages/neumaticos/instalacion/index.vue")
  },
  {
    name: "neumaticos-more",
    path: "/neumaticos/more",
    meta: indexqJZsRfEKFMwcreWrO41iJQ6DRlYhxDh3VHFZ486BJ7wMeta || {},
    component: () => import("/var/www/html/integrado/pages/neumaticos/more/index.vue")
  },
  {
    name: "neumaticos-pdp-id-local_id",
    path: "/neumaticos/pdp/:id()/:local_id()",
    component: () => import("/var/www/html/integrado/pages/neumaticos/pdp/[id]/[local_id].vue")
  },
  {
    name: "neumaticos-plp-doble",
    path: "/neumaticos/plp-doble",
    component: () => import("/var/www/html/integrado/pages/neumaticos/plp-doble/index.vue")
  },
  {
    name: "neumaticos-plp-measurePath",
    path: "/neumaticos/plp/:measurePath()",
    component: () => import("/var/www/html/integrado/pages/neumaticos/plp/[measurePath].vue")
  },
  {
    name: "neumaticos-plp",
    path: "/neumaticos/plp",
    component: () => import("/var/www/html/integrado/pages/neumaticos/plp/index.vue")
  },
  {
    name: "neumaticos-signal",
    path: "/neumaticos/signal",
    meta: index6AkwobYp9x8YN9b1T0m5qrf9nXzvGM6tWHEJWKZnm_kMeta || {},
    component: () => import("/var/www/html/integrado/pages/neumaticos/signal/index.vue")
  },
  {
    name: "neumaticos-tips",
    path: "/neumaticos/tips",
    meta: indexTeY_45BCn6biDP3jHzjWWRs_45o7MHVRPlWu2WZV6EDuPJIMeta || {},
    component: () => import("/var/www/html/integrado/pages/neumaticos/tips/index.vue")
  },
  {
    name: "neumaticos-vehicle",
    path: "/neumaticos/vehicle",
    component: () => import("/var/www/html/integrado/pages/neumaticos/vehicle/index.vue")
  },
  {
    name: "nuestros-locales",
    path: "/nuestros-locales",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/index.vue")
  },
  {
    name: "nuestros-locales-local-antofagasta",
    path: "/nuestros-locales/local-antofagasta",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-antofagasta/index.vue")
  },
  {
    name: "nuestros-locales-local-chicureo",
    path: "/nuestros-locales/local-chicureo",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-chicureo/index.vue")
  },
  {
    name: "nuestros-locales-local-colon",
    path: "/nuestros-locales/local-colon",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-colon/index.vue")
  },
  {
    name: "nuestros-locales-local-concepcion",
    path: "/nuestros-locales/local-concepcion",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-concepcion/index.vue")
  },
  {
    name: "nuestros-locales-local-diagonal",
    path: "/nuestros-locales/local-diagonal",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-diagonal/index.vue")
  },
  {
    name: "nuestros-locales-local-estoril",
    path: "/nuestros-locales/local-estoril",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-estoril/index.vue")
  },
  {
    name: "nuestros-locales-local-irarrazaval",
    path: "/nuestros-locales/local-irarrazaval",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-irarrazaval/index.vue")
  },
  {
    name: "nuestros-locales-local-laflorida",
    path: "/nuestros-locales/local-laflorida",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-laflorida/index.vue")
  },
  {
    name: "nuestros-locales-local-laserena",
    path: "/nuestros-locales/local-laserena",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-laserena/index.vue")
  },
  {
    name: "nuestros-locales-local-maipu",
    path: "/nuestros-locales/local-maipu",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-maipu/index.vue")
  },
  {
    name: "nuestros-locales-local-penalolen",
    path: "/nuestros-locales/local-penalolen",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-penalolen/index.vue")
  },
  {
    name: "nuestros-locales-local-puertomontt",
    path: "/nuestros-locales/local-puertomontt",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-puertomontt/index.vue")
  },
  {
    name: "nuestros-locales-local-rancagua",
    path: "/nuestros-locales/local-rancagua",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-rancagua/index.vue")
  },
  {
    name: "nuestros-locales-local-vicmack",
    path: "/nuestros-locales/local-vicmack",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-vicmack/index.vue")
  },
  {
    name: "nuestros-locales-local-vina",
    path: "/nuestros-locales/local-vina",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-vina/index.vue")
  },
  {
    name: "nuestros-locales-local-vitacura",
    path: "/nuestros-locales/local-vitacura",
    component: () => import("/var/www/html/integrado/pages/nuestros-locales/local-vitacura/index.vue")
  },
  {
    name: "politica-datos-personales",
    path: "/politica-datos-personales",
    component: () => import("/var/www/html/integrado/pages/politica-datos-personales/index.vue")
  },
  {
    name: "por-definir",
    path: "/por-definir",
    meta: index1MVvFCDuZrKfRxXfanakOd4PVfzE3g8CrA_mcjEhhAQMeta || {},
    component: () => import("/var/www/html/integrado/pages/por-definir/index.vue")
  },
  {
    name: "postulaciones-gracias",
    path: "/postulaciones/gracias",
    component: () => import("/var/www/html/integrado/pages/postulaciones/gracias.vue")
  },
  {
    name: "postulaciones",
    path: "/postulaciones",
    component: () => import("/var/www/html/integrado/pages/postulaciones/index.vue")
  },
  {
    name: "quienes-somos",
    path: "/quienes-somos",
    component: () => import("/var/www/html/integrado/pages/quienes-somos/index.vue")
  },
  {
    name: "retiro-y-entrega",
    path: "/retiro-y-entrega",
    component: () => import("/var/www/html/integrado/pages/retiro-y-entrega/index.vue")
  },
  {
    name: "revision-tecnica-calendario",
    path: "/revision-tecnica/calendario",
    component: () => import("/var/www/html/integrado/pages/revision-tecnica/calendario/index.vue")
  },
  {
    name: "revision-tecnica-cliente",
    path: "/revision-tecnica/cliente",
    component: () => import("/var/www/html/integrado/pages/revision-tecnica/cliente/index.vue")
  },
  {
    name: "revision-tecnica-failed",
    path: "/revision-tecnica/failed",
    component: () => import("/var/www/html/integrado/pages/revision-tecnica/failed/index.vue")
  },
  {
    name: "revision-tecnica-finish",
    path: "/revision-tecnica/finish",
    component: () => import("/var/www/html/integrado/pages/revision-tecnica/finish/index.vue")
  },
  {
    name: "revision-tecnica",
    path: "/revision-tecnica",
    component: () => import("/var/www/html/integrado/pages/revision-tecnica/index.vue")
  },
  {
    name: "revision-tecnica-servicio",
    path: "/revision-tecnica/servicio",
    component: () => import("/var/www/html/integrado/pages/revision-tecnica/servicio/index.vue")
  },
  {
    name: "seguridad-y-privacidad",
    path: "/seguridad-y-privacidad",
    component: () => import("/var/www/html/integrado/pages/seguridad-y-privacidad/index.vue")
  },
  {
    name: "terminos-y-condiciones",
    path: "/terminos-y-condiciones",
    component: () => import("/var/www/html/integrado/pages/terminos-y-condiciones/index.vue")
  },
  {
    name: "tren-delantero-calendario",
    path: "/tren-delantero/calendario",
    component: () => import("/var/www/html/integrado/pages/tren-delantero/calendario/index.vue")
  },
  {
    name: "tren-delantero-cliente",
    path: "/tren-delantero/cliente",
    component: () => import("/var/www/html/integrado/pages/tren-delantero/cliente/index.vue")
  },
  {
    name: "tren-delantero-failed",
    path: "/tren-delantero/failed",
    component: () => import("/var/www/html/integrado/pages/tren-delantero/failed/index.vue")
  },
  {
    name: "tren-delantero-finish",
    path: "/tren-delantero/finish",
    component: () => import("/var/www/html/integrado/pages/tren-delantero/finish/index.vue")
  },
  {
    name: "tren-delantero",
    path: "/tren-delantero",
    component: () => import("/var/www/html/integrado/pages/tren-delantero/index.vue")
  }
]